import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material"
import RefreshButton from "../../../../../common/components/refresh_button"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon"
import AlertError from "../../../../../common/components/alert_error"
import { Header } from "./components/header"
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid"
import { useMemo } from "react"
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar"
import { Link as LinkTo } from 'react-router';
import { GenerateSaldoBancarioCadastroColumns } from "./columns"
import { SaldoBancarioCadastroLista } from "../../../domain/models/saldo_bancario_cadastro_lista"
import { useSaldoBancarioCadastroViewModel } from "../../viewModels/saldo_bancario_cadastro_view_model"
import { BackButton } from "../../../../../common/components/back_button"
import { CadastroSaldoBancarioModal } from "./components/cadastro_saldo_bancario"
import { TransferenciaSaldoBancarioModal } from "./components/transferencia_saldo_bancario"


export const SaldoBancarioCadastro = () => {

    const viewModel = useSaldoBancarioCadastroViewModel();

    const columnsDef = useMemo(() => {
        return GenerateSaldoBancarioCadastroColumns();
    }, []);

    return (
        <>
            {/*
             <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={

                    }
                />
            </PageTopBar> 
            */}

            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <div className="flex flex-row gap-2 ">
                            <div className="w-[300px] ">
                                <PrimaryButton
                                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                    onClick={() => viewModel.handleBancoTransferenciaOpenState(true)}>
                                    Transferencia entre Bancos
                                </PrimaryButton>
                            </div>

                            <div className="w-[220px] ">
                                <PrimaryButton
                                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                    onClick={() => viewModel.handleBancoPagamentoEditOpenState(true)}>
                                    Novo Item
                                </PrimaryButton>
                            </div>

                            <BackButton
                                onClick={() => viewModel.handlePageBack()} />

                        </div>
                    }
                />
            </PageTopBar>

            <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
                <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                    <Link underline="hover" color="inherit">
                        Home
                    </Link>
                    <Link underline="hover" color="inherit" component={'span'}>
                        <LinkTo to="/SaldoBancario_lista">Banco Pagamento Saldo</LinkTo>
                    </Link>
                    <Typography className="text-primary-green">
                        Saldo bancário
                    </Typography>
                </Breadcrumbs>
                <div className="div flex justify-start items-center flex-col md:flex-row gap-6 md:gap-0">
                    <div className="flex gap-2 items-center w-full">
                        {viewModel.bancoPagamento && (
                            <div className="w-full mt-2 text-black dark:text-white">
                                <span className="font-extrabold text-xl mr-2">Saldo Bancário |</span>
                                <span className="mx-1 font-bold text-xl">{viewModel.bancoPagamento.nomeBanco}</span>
                                <span className="mx-1 font-light text-xl"> (Ag: {viewModel.bancoPagamento.nrAgencia} </span>
                                <span className="mx-1 font-light text-base">Nr conta: {viewModel.bancoPagamento.nrConta} )</span>
                            </div>
                        )}
                    </div>
                    <RefreshButton onClick={viewModel.handleReload} />
                </div>
                {
                    viewModel.errorMessage !== undefined ? (
                        <div className="w-full">
                            <AlertError
                                messageErro={viewModel.errorMessage}
                                onTryAgain={viewModel.handleReload} />
                        </div>
                    ) : (
                        <>
                            <Header
                                ddlCentroCusto={viewModel.ddlCentroCusto ?? []}
                                ddlSubconta={viewModel.ddlSubconta ?? []}
                                ddlFornecedor={viewModel.ddlFornecedor ?? []}
                                ddlFuncionario={viewModel.ddlFuncionario ?? []}
                                idsCentroCusto={viewModel.filters.idsCentroCusto}
                                idsFornecedor={viewModel.filters.idsFornecedor}
                                idsFuncionario={viewModel.filters.idsFuncionario}
                                idsSubconta={viewModel.filters.idsSubconta}

                                titulo={viewModel.filters.titulo}
                                nrConta={viewModel.filters.nrConta}
                                dataDe={viewModel.filters.dataDe}
                                dataAte={viewModel.filters.dataAte}
                                tipo={viewModel.filters.tipo}
                                valor={viewModel.filters.valor}
                                onClearFilters={viewModel.handleClearFilters}
                                onStatusChange={viewModel.handleTipoChange}
                                handleIdCentroCustoChange={viewModel.handleIdCentroCustoChange}
                                handleIdSubcontaChange={viewModel.handleIdSubcontaChange}
                                handleIdFornecedorChange={viewModel.handleIdFornecedorChange}
                                handleIdFuncionarioChange={viewModel.handleIdFornecedorChange}
                                handleTituloChange={viewModel.handleTituloChange}
                                handleNrContaChange={viewModel.handleNrContaChange}
                                handleDataChange={viewModel.handleDataRangeChange}
                                handleValorChange={viewModel.handleValorChange}

                            />

                            <Stack spacing={0}>
                                <div className="w-full flex flex-row justify-between items-stretch">
                                    {/* <div className="flex flex-col flex-wrap justify-end">
                                        <LegendComponent>
                                            <LegendItemComponent
                                                icon={<LegendIcon color='green' title='A' />}
                                                label='Ativo' />

                                            <LegendItemComponent
                                                icon={<LegendIcon color='red' title='I' />}
                                                label='Inativo' />
                                        </LegendComponent>
                                    </div> */}

                                    <div className="flex flex-col justify-between flex-1">
                                        <TablePagination
                                            component="div"
                                            count={viewModel.pagination.totalItems}
                                            page={viewModel.pagination.page - 1}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                            rowsPerPage={viewModel.pagination.rowsPerPage}
                                            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                                    </div>
                                </div>

                                <StyledDataGrid
                                    tableName="saldo_bancario_cadastro"
                                    disableColumnMenu={false}
                                    showToolbar={true}
                                    disableRowSelectionOnClick={true}
                                    getRowId={(row: SaldoBancarioCadastroLista) => row.idSaldoBancario}
                                    columns={columnsDef}
                                    loading={viewModel.loading}
                                    checkboxSelection={false}
                                    rows={viewModel.saldoBancarioLista}
                                    rowCount={viewModel.saldoBancarioLista.length}
                                    pageSizeOptions={[10, 25, 50, 100]}
                                    paginationMode="server"
                                    paginationModel={{
                                        page: viewModel.pagination.page,
                                        pageSize: viewModel.pagination.rowsPerPage,
                                    }}
                                />

                                <TablePagination
                                    component="div"
                                    count={viewModel.pagination.totalItems}
                                    page={viewModel.pagination.page - 1}
                                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                    rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 25}
                                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                                />
                            </Stack>

                            <CadastroSaldoBancarioModal
                                open={viewModel.openSaldoBancarioCadastroModal}
                                saving={viewModel.saving}
                                hookForm={viewModel.hookForm}
                                onSubmit={viewModel.handleSaldoBancarioCadastroSubmit}
                                onClose={() => viewModel.handleBancoPagamentoEditOpenState(false)}
                            />

                            <TransferenciaSaldoBancarioModal
                                open={viewModel.openSaldoBancarioTransferenciaModal}
                                saving={viewModel.saving}
                                ddlBancos={viewModel.ddlBancosPagamento}
                                hookForm={viewModel.hookForm}
                                onSubmit={viewModel.handleSaldoBancarioCadastroSubmit}
                                onClose={() => viewModel.handleBancoTransferenciaOpenState(false)}
                            />

                        </>
                    )
                }

            </div >
        </>
    )
}


